<template>
    <div class="esign-box">
        <vue-esign 
            class="esign"
            ref="esign" 
            :width="width" 
            :height="height" 
            :isCrop="isCrop" 
            :lineWidth="lineWidth"
            :bgColor="bgColor"
            :isClearBgColor="false"
            lineColor="#666"
        ></vue-esign>
        <div class="btns" ref="btns">
            <el-button type="primary" size="mini" @click="handleReset">清空画板</el-button>
            <el-button v-if="showCreateBtn" type="primary" size="mini" @click="esignHandle">生成新的签名</el-button>
        </div>
    </div>
</template>
  
<script>
import { mapState } from "vuex";

import vueEsign from 'vue-esign';
import base64ImgtoFile from '@/utils/base64ImgtoFile';
import { putObject } from "@/utils/upload";

export default {
    name: "esign",
    components: { vueEsign },
    props: {
        // 显示 生成新的签名 按钮
        showCreateBtn: {
            type: Boolean,
            default: false,
        },
        // 画布宽度，即导出图片的宽度
        width: {
            type: Number,
            defalut: 800
        },
        // 画布高度，即导出图片的高度
        height: {
            type: Number,
            defalut: 300
        },
        // 画笔粗细
        lineWidth: {
            type: Number,
            default: 4
        },
        // 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
        isCrop: {
            type: Boolean,
            default: false
        },
        // 画笔颜色
        lineColor: {
            type: String,
            defalut: '#666'
        },
        // 画布背景色，为空时画布背景透明
        bgColor: {
            type: String,
            defalut: ''
        },
    },
    computed: {
        ...mapState("permission", {
            userInfo: state => JSON.parse(state.userInfo)
        }),
    },
    methods: {
        //src - 图片路径，deg旋转角度
        rotateBase64Img (src, edg){
            return new Promise(async (resolve, reject) => {
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                let imgW// 图片宽度
                let imgH// 图片高度
                let size// canvas初始大小
                if (edg % 90 != 0) {
                    console.error('旋转角度必须是90的倍数!')
                }
                (edg < 0) && (edg = (edg % 360) + 360)
                const quadrant = (edg / 90) % 4 // 旋转象限
                const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 } // 裁剪坐标
                const image = new Image()
                image.crossOrigin = 'anonymous'
                image.src = src
                image.onload = await function() {
                    imgW = image.width
                    imgH = image.height
                    size = imgW > imgH ? imgW : imgH
                    canvas.width = size * 2
                    canvas.height = size * 2
                    switch (quadrant) {
                    case 0:
                        cutCoor.sx = size
                        cutCoor.sy = size
                        cutCoor.ex = size + imgW
                        cutCoor.ey = size + imgH
                        break
                    case 1:
                        cutCoor.sx = size - imgH
                        cutCoor.sy = size
                        cutCoor.ex = size
                        cutCoor.ey = size + imgW
                        break
                    case 2:
                        cutCoor.sx = size - imgW
                        cutCoor.sy = size - imgH
                        cutCoor.ex = size
                        cutCoor.ey = size
                        break
                    case 3:
                        cutCoor.sx = size
                        cutCoor.sy = size - imgW
                        cutCoor.ex = size + imgH
                        cutCoor.ey = size + imgW
                        break
                    }
                    ctx.translate(size, size)
                    ctx.rotate(edg * Math.PI / 180)
                    ctx.drawImage(image, 0, 0)
                    var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey)
                    if (quadrant % 2 == 0) {
                    canvas.width = imgW
                    canvas.height = imgH
                    } else {
                    canvas.width = imgH
                    canvas.height = imgW
                    }
                    ctx.putImageData(imgData, 0, 0)
                    // 获取旋转后的base64图片
                    const newBase64Str = canvas.toDataURL()
                    resolve(newBase64Str);
                }
            })
        },
        // 签名 生成图片
        esignHandle(){
            return new Promise((resolve, reject) => {
                this.$refs['esign'].generate().then(async res => {
                    // console.log(res); //得到了签字生成的base64图片
                    const width = document.documentElement.clientWidth;
                    const height = document.documentElement.clientHeight;
                    let newImg;
                    if (width < height) {
                        // 竖屏
                        newImg = await this.rotateBase64Img(res, 270);  //旋转一下
                    }else{
                        // 横屏
                        newImg = res;
                    }
                    let date = new Date();
                    let timestamp = date.getTime();
                    let signImg = base64ImgtoFile(newImg, timestamp); 
                    putObject(signImg, (url) => {
                        this.$emit('esignHandle', url);
                        resolve(url);
                    });
                }).catch(err => { 
                    //  没有签名，点击生成图片时调用
                    Promise.reject(err);
                    this.$message.error('签名图片生成失败，请重新签名');
                    this.handleReset();
                })
            })
        },
        // 签名 清空画板
        handleReset(){
            this.$refs['esign'].reset();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.esign-box{
    position: relative;
    padding-bottom: 60px;
    .esign{
        border: 1px solid #eee;
      }
      .btns{
        padding: 10px;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 9;
      }
}
</style>
  